import axios from "axios";
// import router from "@/router";
// import {getToken} from "@/uilts/cookie";
//https://ahwater.net/ahwater/
//配置公共前缀
const request = axios.create({
    // baseURL: 'http://waterweather.cn/ahwater',
    baseURL: 'https://ahwater.net/ahwater', //发布地址
    // baseURL: 'http://192.168.10.8:8080/ahwater',

    // baseURL: 'http://192.168.0.104:8081',
    timeout: 8000,
    method: "POST"
})

// // 全局前置拦截器
// request.interceptors.request.use(async config => {
//     
//     
//     //密钥名由后端人员决定
//     const token = getToken()
//     if (token) {
//         //密钥在登录的时候存入了本地
//         config.headers.token = token
//     }
//     //表示放行
//     
//     return config
// }, () => {
//     
// })


export default request
